import React, { useState, useEffect, useCallback, useMemo, useRef, useLayoutEffect } from "react";
import { Link, useHistory, useParams } from 'react-router-dom';
import produce from "immer"
import { toast } from 'react-toastify'
import { useForm, useFieldArray, FormProvider, useFormContext, useWatch } from "react-hook-form";
import { useQuery, queryCache, useMutation } from 'react-query';
import { fetcher } from '../../api/client'; 
import { RadialChart } from 'react-vis';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import { 
    Row, 
    Col,
    Container,
    Nav, 
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Progress,
    Button,
    Label,
    Input,
    CustomInput
} from 'reactstrap';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from "react-i18next";

import { useModalsState } from '../../context/modals'
import { EditorProvider, useEditor, SET_PARTICIPANTS } from '../../context/editor'
import { useProfile } from '../../api/hooks/profile'
import { TemplateProvider, useTemplate, SET_TEMPLATE,UPDATE_DYNAMIC_STATEMENTS, UPDATE_ELEMENT, SET_CURRENT_ELEMENT, UPDATE_ELEMENT_LEVELS, SET_TOTAL_SCORE, RESET } from './context';

import ContractConfigurationContainer from '../../components/ContractConfiguration';
import { ContractPreviewTrato } from "../../components/ContractPreview";
import MainLayout from '../../layouts/MainLayout';
import { fetchTemplateList } from "../../api/actions/templates";
import { createContract } from "../../api/actions/contracts";

import { NewParticipantForm, IndividualParticipantSchema, LegalParticipantSchema, ParticipantSchema } from '../../components/ParticipantForm'

import { mongoObjectId } from '../../utils';
import useLocalStorage from '../../hooks/useLocalStorage';
/** 
{
    contract: ''
    name: ''
    description: ''
    elements: [
        {
            elementId: ''
            name: '',
            description: ''
            levels: [{
                name: 'Nada',
                number: 0,
                score: 0,
                benefits: []
                risks: []
                content: ''
            }]
        }
    ]
}
*/

function ContractPreviewContainer() {
    const [state, dispatch] = useTemplate()
    const participants = useWatch({
        name: 'participants',
        defaultValue: state.partcipants
    })
    console.log({state })

    return (
        <ContractPreviewTrato contract={{ ...state.template, elements: state.elements, participants: state.participants }} card header={true} width={600} elementSelected={state.currentElement} />
    )
}

function CreateContract() {
    const { t } = useTranslation('common')

    return (
        <TemplateProvider>
            <MainLayout className="content-height-footer" 
            paddingBottom={0}>
                <Container tag="section" className="p-0 h-100 overflow-hidden" fluid >
                    <Row noGutters className="p-0 w-100 h-100">
                        <Col lg={8} className="p-4 h-100 overflow-auto">
                            <ContractPreviewContainer />
                        </Col>
                        <Col lg={4} className="h-100 bg-light">
                            <ContractConfiguration />
                        </Col>
                    </Row>
                </Container>
            </MainLayout>
        </TemplateProvider>
    );
}

function Divider() {
    return <div className="border-top pt-3" />
}

function Title({ className, children }) {
    return <h4 className={clsx("text-accent pt-4 text-center font-weight-bold", className)}>{children}</h4>
}




function ContractConfiguration() {
    const [currentStep, setCurrentStep] = useState(1);
    const [isSaved, setIsSaved] = useState(false);
    const history = useHistory();
    const [state, dispatch] = useTemplate()
    const totalSteps = 3;
    const formMethods = useFormContext();
    const score = useMemo(() => {
        const levels = Object.values(state.elementLevels);
        return levels?.reduce((total, level) => {
            total += level.score
            return total
        }, 0) ?? 0
    }, [state.elementLevels])
    const scoreGraph = useMemo(() => [
        { angle: score ?? 0, radius: 1.4, innerRadius: 1.8, color: 1 },
        { angle: state.totalScore - score, radius: 1.4, innerRadius: 1.8, color: 2 }
    ], [score, state.totalScore])
    const scorePercentage = useMemo(() => Math.trunc((score ?? 0)/state.totalScore * 100), [score, state.totalScore])
    const scoreGraphTextStyle = useMemo(() => ({
        fontSize: 25, 
        color: '#6E73FF', 
        top: 30, 
        left: `calc(50% - ${scorePercentage < 10 ? 7.5 : scorePercentage < 100 ? 15 : 22.5}px)` 
    }), [scorePercentage])

    const benefitsVsRisksSummary = useMemo(() => {
        const levels = Object.values(state.elementLevels);
        return levels.reduce((summary, level) => {
            level.benefits.map((benefit) => {
                summary.benefits.push(benefit)
            })
            level.risks.map((benefit) => {
                summary.risks.push(benefit)
            })
           
            return summary
        }, { benefits: [], risks: [] })
    }, [state.elementLevels])
    console.log({elementLevels: state.elementLevels})
    const statementLevels = useMemo(() => {
        const statement = state.elements?.find(el => el.isDynamic && el.type === 'statement')
        const marks = statement?.dynamicElement?.levels?.reduce?.((obj, element) => {
            obj[element.number] = { style: { top: -45, fontSize: 15}, label: element.name }
            return obj;
        }, {}) ?? {}

        // console.log({marks, state})

        return { min: 0, max: statement?.levels?.[statement?.levels?.length ?? 0]?.number ?? 1, marks }
    }, [ state.elements]) 
    const [statementsLevel, setStatementsLevel] = useState(0);
    const meta = { perPage: 30, page: 1, isDynamic: true };
    const { data: templates, status, error } = useQuery(['templates', meta], () => fetcher(fetchTemplateList(meta)), {
        onSuccess: (templates) => {
            if (!state.template._id) {
                dispatch({ type: SET_TEMPLATE, template: templates?.data?.[0] ?? {} })
            }
        }
    })
    const { mutate: mutateCreateContract } = useMutation((data) => fetcher(createContract(data)), {
        onSuccess: ({ data }) => {
            resetCache()
            history.push(`/documents/${data._id}/edit`)
        }
    })

    const handlePrev = () => {
        setCurrentStep(current => Math.max(current - 1, 1))
    }

    const handleNext = () => {
        setCurrentStep(current => Math.min(current + 1, totalSteps))
    }

    const handleContractSelected = (evt) => {
        const selectedTemplate = templates.data.find(template => template._id === evt.target.value)
        dispatch({ type: SET_TEMPLATE, template: selectedTemplate })
    }

    const resetCache = () => {
        localStorage.removeItem('create-contract-cache')
        localStorage.removeItem('create-contract-current-step')
    }

    const handleCreateContract = async () => {
        mutateCreateContract({ templateId: state.template._id, elementLevels: state.elementLevels, language: 'ES' })
    }
    const handleSave = () => {
        localStorage.setItem('create-contract-cache', JSON.stringify(state))
        localStorage.setItem('create-contract-current-step', currentStep)
        setIsSaved(true)
        setTimeout(() => {
            setIsSaved(false)
        }, 1000 * 5)
    }

    const handleReset = () => {
        resetCache()
        dispatch({ type: RESET })
    }

    useLayoutEffect(() => {
        const savedCurrentStep = localStorage.getItem('create-contract-current-step');
        if (savedCurrentStep) {
            setCurrentStep(Number(savedCurrentStep))
        }
    }, [])

    const handleStatementChange = (level) => {
        // const current = dynamicElement.levels.find(l => l.number === level);
        dispatch({ type: UPDATE_DYNAMIC_STATEMENTS, levelNumber: level })
        // setCurrentLevel(current)
        setStatementsLevel(level)
    };

    return (
        <div className="d-flex w-100 flex-column h-100  overflow-auto">
            {
                currentStep === 1 &&
                <>
                    <Title className="mb-5">Tipo de contrato</Title>
                    <div className="px-3 overflow-auto h-100">
                        {templates?.data?.map(template => (
                            <div key={template._id} className="px-3">
                                <CustomInput 
                                    className="checkbox-accent" 
                                    type="radio" 
                                    name="type" 
                                    label={template.name}
                                    id={`type-${template._id}`} 
                                    value={template._id}
                                    onChange={handleContractSelected}
                                    checked={state.template._id === template._id}
                                />
                                {/* <Label className="ml-2" htmlFor={`type-${type._id}`}>
                                    
                                </Label> */}
                                <p className="mb-4 font-size-12 text-muted">
                                    {template.description}
                                </p>
                                <Divider />
                            </div>
                        ))}
                    </div>
                    
                </>
            }
            {
                [2, 3, 4].includes(currentStep) &&
                <div className="p-3 border-bottom d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                        <span className="font-size-12 font-weight-bold">Práctico</span>
                        <Progress className="create-contract-progress ml-2" value={score} max={state.totalScore} />
                        <span className="font-size-12 ml-2 font-weight-bold">Robusto</span>
                    </div>
                    <div>
                        <span className="font-size-12 text-muted pointer underline-on-hover" onClick={handleReset}>Descartar contrato</span>
                    </div>
                    
                </div>
            }      
            {
                currentStep === 2 &&
                <>  
                    <div className="px-3 overflow-auto pb-3 h-100">
                        <Title className="mb-3">Declaraciones</Title>
                        <div className="w-75 mx-auto p-4 mb-3">
                            <Slider 
                                dots 
                                min={statementLevels.min}
                                max={statementLevels.max}
                                value={statementsLevel}
                                onChange={handleStatementChange}
                                step={1}
                                marks={statementLevels.marks}
                                trackStyle={{ background:'#f47b33', height: 10 }}
                                handleStyle={{
                                    borderColor: '#f47b33',
                                    height: 20,
                                    width: 20,
                                    backgroundColor: 'white',
                                }}
                                dotStyle={{ 
                                    borderColor: '#f47b33',
                                    height: 14, 
                                    width: 14, 
                                    bottom: -8,  
                                }}
                                railStyle={{ height: 10 }}
                            />
                        </div>
                        <BenefitsVsRisks 
                            risks={statementLevels.risks}
                            benefits={statementLevels.benefits}
                            risksEmptyMessage="La opción que seleccionaste no tiene ningún riesgo"
                            benefitsEmptyMessage="La opción seleccionada no tiene ventajas"
                        />
                        <Title className="mb-3">Cláusulas</Title>
                        <div className="px-3 overflow-auto pb-3">
                            {state.elements?.filter(el => el.isDynamic && el.type === 'clause').map((element) => {
                                const currentLevelId = state.elementLevels[element._id]?.number ?? 0;
                                console.log({currentLevelId})
                                return (
                                    <DynamicElementItem element={element} currentLevelId={currentLevelId} />
                                )
                            })}
                        </div>
                    </div>
                  
                    
                </>
            }
            {
                currentStep === 3 && 
                <>
                    <div className="h-100 overflow-auto">
                        <Title className="mb-2">Participantes del contrato</Title>
                        <p className="text-center px-3 pt-3 text-muted">
                            Se establecen los lineamientos para llevar a cabo la prestación de los servicios que se especifican
                        </p>
                        <div className="d-flex justify-content-center mx-auto mb-4 position-relative w-100">
                            <RadialChart height={100} width={100} data={scoreGraph} colorRange={['#6E73FF', '#d9dafc']} />
                            <div className="position-absolute" style={scoreGraphTextStyle}>{scorePercentage ?? 0}</div>
                        </div>
                        <BenefitsVsRisks 
                            risks={benefitsVsRisksSummary.risks}
                            risksEmptyMessage="Para tu contrato no se tienen riesgos identificados"
                            benefits={benefitsVsRisksSummary.benefits}
                            benefitsEmptyMessage="Para tu contrato no se tienen ventajas adicionales"
                        />
                    </div>
                </>
            }
            {
                currentStep === 4 && 
                <>
                    <div className="h-100 overflow-auto">
                        <Title className="mb-2">Configuracion</Title>
                        {/* <div className={clsx("general-configuration px-4", isPdf && 'mt-2')}>
                            <label>{t('shield')}</label>
                            <Select options={shields} value={shieldType} onChange={onShieldChange} isDisabled={!isEditable} />
                            <label className="mt-2">{t('forms.language')}</label>
                            <Select options={languages} value={currentLanguage} onChange={onLanguageChange} isDisabled={!isEditable} />
                        </div> */}
                        {state.templateId && <ContractConfigurationForm 
                            contract={state.template}
                            // contract={state.participants}
                        />}
                    </div>
                </>
            }
            <div className={clsx("p-3 d-flex border-top", currentStep === 1 ? "justify-content-end" : "justify-content-between")}>
                { currentStep !== 1 &&
                    <Button 
                        className="d-flex align-items-center" 
                        size="sm" 
                        color="accent-100"
                        onClick={handlePrev}
                    >
                        <FontAwesomeIcon icon="chevron-left" className="text-white mr-1" /> Anterior
                    </Button> 
                }
                <div className="d-flex">
                    { currentStep !== 1 &&
                        <Button 
                            className="d-flex align-items-center mr-1" 
                            size="sm" 
                            onClick={handleSave}
                        >
                            <FontAwesomeIcon icon="save" className="text-dark mr-1" /> { isSaved ? "Guardado" : "Guardar" }
                        </Button> 
                    }
                    <Button 
                        className="d-flex align-items-center" 
                        size="sm" 
                        color="accent-100"
                        onClick={currentStep === totalSteps ? handleCreateContract : handleNext}
                    >
                        { currentStep === totalSteps ? 'Generar' : 'Siguiente'}  <FontAwesomeIcon icon="chevron-right" className="text-white ml-1" />
                    </Button>
                </div>
            </div>
        </div>
    )
}

const defaultParticipants = [
    {
        name: '',
        last_name: '',
        representative: '',
        phone: '',
        label: 'La Parte',
        email: ''
    }
]
// Hook
function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef();
    
    // Store current value in ref
    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes
    
    // Return previous value (happens before update in useEffect above)
    return ref.current;
  }


function ContractConfigurationForm({ contract, onSubmit }) {
    const { register, control, handleSubmit, watch, reset, trigger, setError, setValue, getValues, errors } = useFormContext({
        defaultValues: {
            shield: 1,
            language: 'es',
            fillMyData: '',
            participants: contract.participants ?? defaultParticipants ?? []
        }
   });
   const { profile } = useProfile()
    const [participants, setParticipants] = useState(contract.participants)
    // const { fields, remove, update } = useFieldArray({
    //     name: 'participants',
    //     control,
    //     keyName: "_id"
    // })
    const fillMyData = watch('fillMyData', "")
    const previousFillMyData = usePrevious(fillMyData)
    const f2 = useRef("")

    const memoizedParticipants = useMemo(() => {
        return contract.participants
    },  [contract.participants])

    useEffect(() => {
        if (memoizedParticipants) {
            setParticipants(memoizedParticipants)
            setValue('participants', memoizedParticipants)
        }
    }, [memoizedParticipants])

    const handleParticipantUpdate = (participant, index, changes) => {
        setParticipants(produce(draft => {
            if (changes.obligation && draft[index]) {
                draft[index].obligation = changes.obligation;
            } else if (changes.label && draft[index]) {
                draft[index].label = changes.label
            }
        }))
    }

    const handleRemoveParticipant = (participant, index) => {
        const { participants } = getValues()
        const filteredParticipants = participants.filter(p => p._id !== participant._id)
        setParticipants(filteredParticipants)
    }

    const handleAddParticipant = () => {

        setParticipants(produce(draft => {
            draft.push({
                _id: mongoObjectId(),
                obligation: 'individual',
                name: '',
                last_name: '',
                representative: '',
                phone: '',
                email: '',
                label: `Participante ${(draft?.length ?? 0) + 1}`,
              })
              trigger()
        }))
        
    }

    const handleFillMyData = (fillMyData) => {
        if (fillMyData === "reset") {
            const participantToReset = memoizedParticipants.find(p => previousFillMyData === p._id);
            console.log({participantToReset})
            const newParticipants = participants.map(participant => { 
                if (previousFillMyData === participant._id) {
                    return participantToReset ?? {
                        name: '',
                        last_name: '',
                        label: participant.label,
                        representative: '',
                        phone: '',
                        email: ''
                    };
                }
                return participant
              })
            setValue('fillMyData', "")
            setValue('participants', newParticipants)
        } else if (fillMyData?.length && fillMyData !== 'reset') {
            const newParticipants = participants.map((participant, i) => {
                if (fillMyData === participant._id) {
                    return {
                        ...participant,
                        name: participant.obligation === 'legal' ? profile.office.name : profile.givenName,
                        last_name: profile.familyName,
                        email: profile.email,
                        label: participant.label,
                        phone: profile.phone,
                        representative: profile.office ? profile.office.representative : '',
                    }
                }
    
                return participant
            })
            f2.current = fillMyData;
            setValue('participants', newParticipants)
        }
    }


    useEffect(() => {
        console.log("render")
        handleFillMyData(fillMyData)
    }, [fillMyData])

    // console.log({participants, pats: contract.participants, values: getValues()})

    return (
        <div>
            {
                participants?.map((participant, index) => (
                    <NewParticipantForm 
                        key={participant._id}
                        header
                        editable
                        index={index}
                        control={control}
                        getValues={getValues}
                        participant={participant}
                        fillMyData={fillMyData}
                        onRemove={handleRemoveParticipant}
                        onParticipantUpdate={handleParticipantUpdate}
                        errors={errors?.participants?.[index]}
                        name={`participants[${index}]`}
                        register={register}
                    />
                ))
            }
            <div 
                className="mx-3 my-4 color-accent pointer" 
                onClick={handleAddParticipant}
                // disabled={!isEditable}
            >
                + Agregar participante
            </div>
        </div>
    )
}

function DynamicElementItem({ element, currentLevelId }) {
    const dynamicElement = element.dynamicElement;
    const [currentLevel, setCurrentLevel] = useState({});
    const [,dispatch] = useTemplate();
    const marks = dynamicElement.levels.reduce((obj, element) => {
        obj[element.number] = { style: { top: -45, fontSize: 15}, label: element.name }
        return obj;
    }, {})

    const handleChange = (level) => {
        const current = dynamicElement.levels.find(l => l.number === level);
        dispatch({ type: UPDATE_ELEMENT, element: { _id: element._id, content: current.content }})
        dispatch({ type: UPDATE_ELEMENT_LEVELS, elementId: element._id, level: current })
        setCurrentLevel(current)
    };

    const handleClick = () => {
        dispatch({ type: SET_CURRENT_ELEMENT, elementId: element._id })
    }

    useEffect(() => {
        const current = dynamicElement.levels.find(l => l.number === currentLevelId);
        setCurrentLevel(current)
    }, [dynamicElement.levels, currentLevelId])
    
    return (
        <div onClick={handleClick}>
            <div className="text-center py-3">
                <h5 className="font-weight-bold">{dynamicElement.name}</h5>
                <p className="text-center text-muted">{currentLevel.description ?? dynamicElement.description}</p>
            </div>
            {!dynamicElement.hasSameContent &&  <div className="w-75 mx-auto p-4 mb-3">
            <Slider 
                    dots 
                    min={0}
                    max={dynamicElement.levels.length - 1}
                    value={currentLevel.number}
                    onChange={handleChange}
                    step={1}
                    marks={marks}
                    trackStyle={{ background:'#f47b33', height: 10 }}
                    handleStyle={{
                        borderColor: '#f47b33',
                        height: 20,
                        width: 20,
                        backgroundColor: 'white',
                    }}
                    dotStyle={{ 
                        borderColor: '#f47b33',
                        height: 14, 
                        width: 14, 
                        bottom: -8,  
                    }}
                    railStyle={{ height: 10 }}
                />
            </div> }
            <BenefitsVsRisks 
                risks={currentLevel.risks}
                benefits={currentLevel.benefits}
                risksEmptyMessage="La opción que seleccionaste no tiene ningún riesgo"
                benefitsEmptyMessage="La opción seleccionada no tiene ventajas"
            />
            <Divider />
        </div>
    )

}


function BenefitsVsRisks({ benefits = [], risks = [], risksEmptyMessage, benefitsEmptyMessage }) {
    return (
        <Container className="pb-3">
            <Row className="justify-content-center m-auto">
                <Col>
                    <BenefitsVsRisksItem 
                        title="Riesgos"
                        icon="exclamation-circle"
                        iconClassName="text-danger" 
                        list={risks}
                        emptyMessage={risksEmptyMessage}
                    />
                </Col>
                <Col>
                    <BenefitsVsRisksItem 
                        title="Ventajas"
                        icon="check-circle"
                        iconClassName="text-success" 
                        list={benefits}
                        emptyMessage={benefitsEmptyMessage}
                    />

                </Col>
            </Row>
        </Container>
    )
}

function BenefitsVsRisksItem({ title, icon, iconClassName, list, emptyMessage }) {
    return (
    <div className="">
        <div className=" bg-light font-weight-bold font-size-14 mr-1">
            <FontAwesomeIcon icon={icon} className={clsx("text-success", iconClassName)} /> {title}
        </div>
        <div className="font-size-14 text-muted p-2 overflow-auto">
            {list?.map(item => <div>- {item}</div>)}
            {!list.length && <span>- {emptyMessage}</span>}
        </div>
    </div>)
}

export default CreateContract;



